var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tag',{attrs:{"type":_vm.type}},[_c('b-icon',{attrs:{"icon":"clock","size":"is-small"}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }